// Years a locale has data for, from REACT_APP_SURVEY_AVAILABLE_YEARS_{LOCALE}, e.g. "2026,2018".
//
// Entries are trimmed because an untrimmed " 2018" becomes a data path that 404s to the SPA shell
// and then fails to parse. A missing variable yields [] rather than throwing — these are read
// inside route elements and render bodies, where a TypeError blanks the app.
const availableYearsFor = (locale) =>
  (
    process.env[`REACT_APP_SURVEY_AVAILABLE_YEARS_${locale.toUpperCase()}`] ||
    ""
  )
    .split(",")
    .map((year) => year.trim())
    .filter(Boolean);

export default availableYearsFor;
